import { useRef } from "react";

import styled from "styled-components";

import {
  FloatingButton,
  InnerWrapper,
  iconPaddingRight,
} from "NavBar/components/FloatingButtonPanel/ButtonStyles";
import IconWrapper from "NavBar/components/FloatingButtonPanel/IconWrapper";
import useIsSelected from "NavBar/components/useIsSelected";
import { navSectionKeys } from "NavBar/navBarStore";
import { useCloseNavIfOpen } from "NavBar/stateHooks";

import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrSimpleReveal from "UI/FnrSimpleReveal";
import FnrTypography from "UI/FnrTypography";
import { navAccentColors } from "UI/colors";

import {
  useIsFocusVisible,
  useIsHovered,
} from "Utilities/Hooks/useIsHoverFocused";
import { addLeadingSlash } from "Utilities/stringTransformers";

import { useShowButtonText } from "./floatingSearchStore";
import {
  activeBackgroundColor,
  inactiveBackgroundColor,
} from "./styleConstants";

const importGroupsManagement = () => import("GroupsManagement");

const AllButton = () => {
  const buttonRef = useRef();
  const normalizedTo = addLeadingSlash("groupsmanagement");
  const isSelected = useIsSelected(normalizedTo);
  const isHovered = Boolean(useIsHovered(buttonRef));
  const isFocusVisible = Boolean(useIsFocusVisible(buttonRef));
  const closeNavIfOpen = useCloseNavIfOpen();

  const showButtonText = useShowButtonText();

  const handleClick = () => {
    window.fnReactBus.goToUrl(normalizedTo);
    closeNavIfOpen();
  };

  return (
    <FloatingButton
      ref={buttonRef}
      onClick={handleClick}
      onMouseEnter={importGroupsManagement}
      data-cy="NavBar_FloatingAllButton"
      $glowColor={navAccentColors[navSectionKeys.groups][0]}
      $noGlow={!isSelected}
      $backgroundColor={
        isSelected ? activeBackgroundColor : inactiveBackgroundColor
      }
    >
      <InnerWrapper>
        <IconWrapper
          $paddingRight={showButtonText ? iconPaddingRight : 0}
          $isSearchActive={!showButtonText}
        >
          <FnrContainedIcon
            icon="list fas"
            size="sm"
            color="textLight"
            backgroundColor="transparent"
            noPadding
            noAnimation
            shadow
          />
        </IconWrapper>
        <FnrSimpleReveal show={showButtonText}>
          <TextWrapper>
            <FnrTypography
              fontSize="13px"
              lineHeight={1}
              color="textLight"
              shadow
              noWrap
            >
              ALL
            </FnrTypography>
          </TextWrapper>
        </FnrSimpleReveal>
        <FnrSimpleReveal show={showButtonText && (isHovered || isFocusVisible)}>
          <FnrTypography
            fontSize="13px"
            lineHeight={1}
            color="textLight"
            shadow
            noWrap
          >
            GROUPS
          </FnrTypography>
        </FnrSimpleReveal>
      </InnerWrapper>
    </FloatingButton>
  );
};

const TextWrapper = styled.div`
  padding-right: 4px;
`;

export default AllButton;
